export default "__VITE_ASSET__Dhp4FAg1__"